<div class="shortlink-container">
  <!-- Display the appropriate component based on authentication and PageType -->
  <ng-container *ngIf="!validationError && currentComponent">
    <ng-container 
      *ngComponentOutlet="currentComponent; 
      inputs: { onAuthSuccess: onAuthenticationSuccess.bind(this) }">
    </ng-container>
  </ng-container>
</div>

